import {Tabs as AntTabs} from "antd";

export const Tabs = AntTabs;
export default Tabs;
